/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getBizID, getServices } from "../../libs/todoSlice";
import { useEffect } from "react";
import { getSharedTokenRedux, setSharedTokenRedux } from "../../libs/digitalWorkFlowSlice";
import axios from "axios";
import LoadingComponent from "../../lib/LoadingComponent";
import Swal from "sweetalert2";

const EStamp = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const services = useSelector(getServices);
  const params = useParams();
  const businessID = useSelector(getBizID);

  const getEStamp = async () => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/estamp/redirect/login`
      })

      if (data && data.data && data.data.redirect_url) {
        window.open(data.data.redirect_url, '_blank');
        navigate(`/${params.prefix}/home`)
      }
    } catch (response) {
        const { status } = response
        if (status === 401) {
          navigate(`/${params.prefix}`)
        }
        Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
        });
    }
  };

  useEffect(() => {
    getEStamp();
  }, [params.prefix]);

  return <LoadingComponent width={150} height={150} />;
};

export default EStamp;
